// db.ts
import { Injectable } from '@angular/core';
import { HistoryMenuItem, ReportSearchParamRecord, UserAccessControl } from '@app/models';

import Dexie, { Table } from 'dexie';

export interface TableWithId {
  _id: string;
}

export interface GenericRecord {
  _id: string;
  [key: string]: any; // dynamic fields allowed.
}

@Injectable()
export class AppStorageDb extends Dexie {
  historyMenuItems!: Table<HistoryMenuItem, string>;
  userAccessControls!: Table<UserAccessControl, string>;
  reportSearchRecords!: Table<GenericRecord, string>;
  reportSearchParams!: Table<ReportSearchParamRecord, string>;
  accountsGridSearch!: Table<GenericRecord, string>;

  constructor() {
    try {
      // Creates the database for user.
      super('Yeehro User DB');

      // Dexie.delete('Yeehro User DB'); // If needing to reset db for dev instead of changing version.

      // List what collections should be stored on front end. Changing version here will add new collections/fields. List any possible query or search fields.
      this.version(6).stores({
        historyMenuItems: 'id, label, moduleName, route, visitedAt',
        userAccessControls: 'storageId',
        users: '_id, expiresAt',
        teams: '_id, expiresAt',
        reportSearchRecords: '_id, _originalOrderIndex, createdAt, expiresAt',
        reportSearchParams: '_id, moduleName, createdAt, expiresAt'
      });

      // v7: Remove users and teams tables (moved to in-memory cache).
      this.version(7).stores({
        users: null,
        teams: null
      });

      // v8: Add accountsGridSearch so the accounts paginator survives the full-page
      // reload that fires when a user drills into a related record (Case 1474). One
      // row keyed _id='current' holds { params, results, expiresAt }.
      this.version(8).stores({
        accountsGridSearch: '_id, expiresAt'
      });

      this.on('populate', () => this.populate());

      // Opening the database.
      this.open()
        .then(data => {
          // console.log("DB Opened. Data: ", data);
          this.showEstimatedQuota();
          this.setPersist();
        })
        .catch(err => console.log('Error opening database: ', err?.message));
    } catch (_err) {
      console.log('Error initializing offline db: ', _err);
    }
  }


  async setPersist() {
    this.isStoragePersisted().then(async isPersisted => {
      if (isPersisted) {
        console.log(":) Storage is successfully persisted.");
      } else {
        console.log(":( Storage is not persisted.");
        console.log("Trying to persist..:");
        if (await this.persist()) {
          console.log(":) We successfully turned the storage to be persisted.");
        } else {
          console.log(":( Failed to make storage persisted");
        }
      }
    })
  }


  async persist() {
    return await navigator.storage && navigator.storage.persist && navigator.storage.persist();
  }


  async isStoragePersisted() {
    return await navigator.storage && navigator.storage.persisted && navigator.storage.persisted();
  }


  async showEstimatedQuota() {
    if (navigator.storage && navigator.storage.estimate) {
      const estimation = await navigator.storage.estimate();

      console.log(`Quota: ${estimation.quota}`);
      console.log(`Usage: ${estimation.usage}`);
    } else {
      console.error("StorageManager not found");
    }
  }


  async populate() {
    // const todoListId = await db.todoLists.add({
    //   title: 'To Do Today',
    // });
    // await db.todoItems.bulkAdd([
    //   {
    //     todoListId,
    //     title: 'Feed the birds',
    //   },
    //   {
    //     todoListId,
    //     title: 'Watch a movie',
    //   },
    //   {
    //     todoListId,
    //     title: 'Have some sleep',
    //   },
    // ]);
  }
}

export const db = new AppStorageDb();